import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Sidebar from './components/Sidebar';
import TopNav from './components/TopNav';
import MissionBoard from './pages/MissionBoard';
import AssetRoom from './pages/AssetRoom';
import Timeline from './pages/Timeline';
import Settings from './pages/Settings';
import OperationsGuide from './pages/OperationsGuide';
import Stakeholders from './pages/Stakeholders';
import Support from './pages/Support';
import BrandMark from './components/BrandMark';

function App() {
  const [activeView, setActiveView] = useState('mission');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderView = () => {
    switch (activeView) {
      case 'mission': return <MissionBoard />;
      case 'assets': return <AssetRoom />;
      case 'timeline': return <Timeline />;
      case 'guide': return <OperationsGuide setActiveView={setActiveView} />;
      case 'stakeholders': return <Stakeholders />;
      case 'support': return <Support />;
      case 'settings': return <Settings />;
      default: return <MissionBoard />;
    }
  };

  return (
    <div className="flex h-screen w-full bg-slate-950 overflow-hidden relative text-ice">
      {/* Dynamic Background */}
      <div className="absolute inset-0 bg-[size:40px_40px] bg-grid-pattern opacity-10 pointer-events-none"></div>
      <div className="absolute top-[-10%] right-[-10%] w-[50%] h-[50%] bg-rocket-500/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <Sidebar 
        activeView={activeView} 
        setActiveView={setActiveView} 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen} 
      />

      <div className="flex-1 flex flex-col min-w-0 relative z-10">
        <TopNav toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeView}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="h-full"
            >
              {renderView()}
            </motion.div>
          </AnimatePresence>
        </main>

        <footer className="py-4 px-6 border-t border-slate-800/50 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-mono text-slate-500 shrink-0">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <BrandMark className="w-4 h-4 opacity-50" />
              <span className="font-bold tracking-tighter uppercase">LaunchLayer Demo</span>
            </div>
            <span className="hidden md:inline text-slate-800">|</span>
            <span className="uppercase">Internal Mission Build v2.4.0</span>
          </div>
          <div className="text-rocket-500 font-bold tracking-widest uppercase">
            Made by LingLink AI and DigLab AI
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;